module.exports = require("intersection-observer");